import {createContext} from 'react'

const ProductosServiciosContext = createContext()

export default ProductosServiciosContext